export enum AppointmentStatus {
  New = "NEW",
  Arrived = "ARRIVED",
  Started = "STARTED",
  Completed = "COMPLETED",
  Cancelled = "CANCELLED",
  NoShow = "NO SHOW",
  Confirmed = "CONFIRMED",
  Archived = "ARCHIVED",
}
